<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/masterData/agreements/${inputs.id}`
            : `/masterData/agreements`
        "
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("Seleccionar razón social") }}
              </label>
              <app-input
                v-if="select_show"
                id="inputs_organization"
                type="search-select"
                v-model="inputs.organization_id"
                :list="organization"
                :required="true"
              />

              <app-input
                v-if="!select_show"
                id="inputs_organization"
                type="select"
                v-model="inputs.organization_id"
                :list="organization"
                @change="changeOrganization(inputs.organization_id)"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-12" v-if="!select_show">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("Nombre") }}
              </label>
              <app-input
                id="inputs_name"
                type="text"
                v-model="org_name"
                :disabled="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("Código") }}
              </label>
              <app-input
                id="inputs_code"
                type="text"
                v-model="inputs.code"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("Fecha de firma del convenio") }}
              </label>
              <app-input
                id="inputs_agreement_signed"
                type="date"
                v-model="inputs.agreement_signed"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("Fecha de inicio del convenio") }}
              </label>
              <app-input
                id="inputs_agreement_star"
                type="date"
                v-model="inputs.agreement_start"
                :required="true"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("Fecha de fin del convenio") }}
              </label>
              <app-input
                id="inputs_agreement_end"
                type="date"
                v-model="inputs.agreement_end"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="mb-0">Activo</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_active"
                :list="isActive"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Descripción</label>
              <app-input
                type="textarea"
                v-model="inputs.description"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Archivo de convenio</label>
              <app-input
                :class="{ 'loading-opacity': preloader }"
                type="file"
                :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
                v-if="!org.agreement_file"
              />
              <div class="mt-2">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs.organization, 'agreement_file')
                  "
                  v-if="org.agreement_file"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="confirmed('agreement_file')"
                  v-if="org.agreement_file"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import { axiosGet } from "../../../../../../../resources/js/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { quillEditor },
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
    accreditationActivityList: Array,
    accreditationTypeList: Array,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      organization: [],
      org_name: "",
      inputs: "",
      org: "",
      select_show:false,
      modalId: "agreements-modal-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.select_show = true;
      this.inputs = {
        is_active: 1,
        agreement_end: new Date(),
        agreement_start: new Date(),
        agreement_signed: new Date(),
      };
    }
    this.selectedUrl = "";
    this.organizationList();
  },
  methods: {
    submit() {
      const tmp = { ...this.inputs };
      if (tmp.agreement_end) {
        const d = tmp.agreement_end;
        tmp.agreement_end = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }

      if (tmp.agreement_start) {
        const d = tmp.agreement_start;
        tmp.agreement_start = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }

      if (tmp.agreement_signed) {
        const d = tmp.agreement_signed;
        tmp.agreement_signed = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(tmp)) {
        formData.append(key, value);
      }

      this.save(formData);
    },

    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    organizationList() {
      const url = "/masterData/agreements/organizationList2";
      axiosGet(url).then((response) => {
        this.organization = response.data;
      });
    },

    afterSuccessFromGetEditData(response) {
      const tmp = response.data;
      this.inputs = tmp;
      this.preloader = false;
      this.inputs.agreement_end = this.correctDate(response.data.agreement_end)
      this.inputs.agreement_start = this.correctDate(response.data.agreement_start)
      this.inputs.agreement_signed = this.correctDate(response.data.agreement_signed)
      this.org = response.data.organization;
      this.changeOrganization(response.data.organization.id);
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    correctDate(fecha) {
      fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + parseInt(1));
      return fecha;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    confirmed(selected) {
      this.inputs.organization[selected] = null;
    },

    changeOrganization(index) {
      const url = `/masterData/agreements/organizationName/${index}`;
      axiosGet(url).then((response) => {
        this.org_name = response.data.name;
      });
    }
  },
};
</script>
